<div class="indicator-container">
    <div class="color-picker-container">
        <input readonly class="color-input" [style.background]="color" />
    </div>

    <div class="range-value-container">
        <div class="container-name">
            {{ 'mimics.settings.range-indicator.min' | translate }}
        </div>
        <input
            #minInput
            class="range-input"
            type="number"
            [min]="minRange"
            [max]="maxRange"
            [(ngModel)]="min"
            (ngModelChange)="minChange($event)"
            (blur)="emitColorChange()" />
    </div>
    <div class="range-value-container">
        <div class="container-name">
            {{ 'mimics.settings.range-indicator.max' | translate }}
        </div>
        <input
            #maxInput
            class="range-input"
            type="number"
            [min]="minRange"
            [max]="maxRange"
            [(ngModel)]="max"
            (ngModelChange)="maxChange($event)"
            (blur)="emitColorChange()" />
    </div>
    <div class="option-container">
        <mat-icon class="delete-icon" svgIcon="delete" (click)="colorStateDelete()"></mat-icon>
        <div class="option">
            <div class="delete">
                {{ 'mimic.settings.remove.tooltip' | translate }}
            </div>
        </div>
    </div>
</div>
